import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Block from './Block';
import H2 from './H2';
import Grid from './Grid';
import Cell from './Cell';
import MediaDisplay from './MediaDisplay';

const PageFullVideo = ({ content }) => {
  const hasTitle = content.primary.title1 && content.primary.title1.text;

  return (
    <Block
      id={content.primary.internal_link_id}
      backgroundColor={content.primary.background_color}
      py={{ mobile: '0', tablet: 'baseUp12' }}
    >
      <Grid>
        <Cell size={1}>
          {hasTitle && (
            <H2
              pt={{ mobile: 'baseUp4', tablet: '0' }}
              px="baseUnit"
              mb="baseUp4"
              color={
                ['coral', 'coralLight', 'transparent'].includes(
                  content.primary.background_color,
                )
                  ? 'blueDark'
                  : 'coral'
              }
            >
              {content.primary.title1.text}
            </H2>
          )}

          <MediaDisplay content={content.primary} />
        </Cell>
      </Grid>
    </Block>
  );
};

PageFullVideo.propTypes = {
  content: PropTypes.shape({
    primary: PropTypes.shape({
      internal_link_id: PropTypes.string,
      title1: PropTypes.shape({
        text: PropTypes.string.isRequired,
      }).isRequired,
      video: PropTypes.shape({}),
      amazon_video_path: PropTypes.arrayOf(PropTypes.shape({})),
      background_color: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default PageFullVideo;

export const query = graphql`
  fragment PageFullVideoFragment on PrismicPageDataBodyFullVideo {
    id
    slice_type
    primary {
      internal_link_id
      title1 {
        text
      }
      video {
        title
        embed_url
        provider_name
      }
      amazon_video_path
      background_color
    }
  }
`;
